import React from "react";
import { Card, CardBody, CardTitle } from "reactstrap";
import ReactApexChart from "react-apexcharts";

const FinansGrafik = ({ monthlyData }) => {
  const series = [{ name: "Sistem Cirosu", data: monthlyData || Array(12).fill(0) }];
  
  const options = {
    chart: { type: "area", height: 240, toolbar: { show: false } },
    colors: ["#556ee6"],
    dataLabels: { enabled: false },
    stroke: { curve: "smooth", width: 2 },
    fill: { type: "gradient", gradient: { shadeIntensity: 1, opacityFrom: 0.45, opacityTo: 0.05, stops: [20, 100, 100, 100] } },
    xaxis: { categories: ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"] },
    yaxis: { labels: { formatter: (value) => value.toLocaleString("tr-TR") + " ₺" } }
  };

  return (
    <Card className="shadow-sm border-0">
      <CardBody>
        <CardTitle className="mb-3">Aylık Ciro Özeti</CardTitle>
        <ReactApexChart series={series} options={options} type="area" height={240} className="apex-charts" />
      </CardBody>
    </Card>
  );
};

export default FinansGrafik;